import React, { useContext, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import {
  DashboardNav,
  CreateRecordNav,
  ConsultRecordNav,
  ConsultRecordNavTrdExplorer,
  TaskBoxNav,
  ReportsNav,
  ProcessManagementNav,
  TrashNav,
  ParameterNav,
  FormsDesignerNav,
  FormsDesignerNavConsult,
  ListDesignerNav,
  AdminUsersThirdPartyAccounts,
  AdminUsersAndRoleGroupsNav,
  AdminUsersAndRoleNav,
  AdminUsersGroupsNav,
  AdminRoleGroupsNav,
  AdminUsersNav,
  AdminUsersRoleNav,
  MetricsNav,
  MetricsOnlyNav,
  MetricsLogsNav,
  WorkFlowDesignerNav,
  IntegrationsNav,
  WorkFlowDesignerNavConsult,
  DocumentTemplatesDesignerNav,
  AdminUserWorkGroupNav,
  ParameterDocumentaryTypeNav,
  DataExportNav,
} from "./NavItems";
import { enumsIntegrationType, enumsRolesPermissions, enumsTypeUser } from "utils/enums";
import { useTranslation } from "react-i18next";
import useLogin from "hooks/useLogin";
import useShowConsultExpedient from "customsHooks/useShowConsultExpedient";
import MetisMenu from "react-metismenu";
import Context from "contextAPI/UserContext";

const Nav = () => {
  const { t } = useTranslation();
  const {
    userType,
    rolesPermissionsGranted,
    designerForms,
    designerFormsPermissions,
    workflowAllForms,
    workflowFormsPermissions,
    integrationOptions,
  } = useContext(Context);

  //CONTROL AND PERMISSIONS
  const { isLogged } = useLogin();
  const { viewSubMenuExpedientConsult } = useShowConsultExpedient();

  let access;
  let accessTRD;
  let accessDesignerForms;
  let accessDesignerFormsConsult;
  let accessWorkflowsForms;
  let accessWorkflowsFormsConsult;
  let accessList;
  let accessUserManager;
  let accessAdminThirdPartyAccounts;
  let accessRoles;
  let accessIntegrations;
  let accessWorkGroups;
  let accessProcessManagement;
  let accessMetrics;
  let accessAuditLogs;
  let accessTemplateDesigner;

  let renderListDesignerNav = null;
  let renderReportsNav = null;
  let renderProcessManagementNav = null;
  let titleHeadingNav = null;
  let renderParameterNav = null;
  let renderParameterDocumentaryTypeNav = null;
  let renderFormsDesignerNav = null;
  let renderFormsDesignerNavConsult = null;
  let renderTemplatesDesignerNav = null;
  let renderListDesignerForm = null;
  let renderAdminUsersThirdPartyAccounts = null;
  let renderAdminUsersAndRoleGroupsNav = null;
  let renderAdminUsersAndRoleNav = null;
  let renderAdminUsersGroupsNav = null;
  let renderAdminRoleGroupsNav = null;
  let renderAdminUsersNav = null;
  let renderAdminUsersRoleNav = null;
  let renderAdminUserWorkGroupNav = null;
  let renderWorkFlowDesignerNav = null;
  let renderWorkFlowDesignerNavConsult = null;
  let renderMetricsNav = null;
  let renderTitleIntegrations = null;
  let renderIntegrationsNav = null;

  const translateNav = (nav) =>
    nav.map((item) => {
      let resolvedLabel = item.label;

      if (item.labelKey) {
        resolvedLabel = t(item.labelKey);
      } else if (typeof item.label === "function") {
        resolvedLabel = item.label();
      }

      const translatedItem = {
        ...item,
        label: resolvedLabel,
      };

      if (Array.isArray(item.content)) {
        translatedItem.content = translateNav(item.content);
      }

      return translatedItem;
    });

  /**
   * Checks if the user is logged in and has a user type other than QUERY.
   * Sets access to true if conditions are met, false otherwise.
   */
  if (isLogged === true && userType !== enumsTypeUser.QUERY) {
    access = true;
  } else {
    access = false;
  }

  /**
   * Checks the user's access to TRD based on their login status, user type, and role permissions.
   * If the user is logged in as a standard user with specific role permissions or as a query user,
   * sets the access to TRD to true; otherwise, sets it to false.
   */
  if (
    (isLogged === true &&
      userType === enumsTypeUser.STANDARD &&
      rolesPermissionsGranted !== null &&
      rolesPermissionsGranted.includes(enumsRolesPermissions.TRD_CONSFIGURATION)) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessTRD = true;
  } else {
    accessTRD = false;
  }

  /**
   * Checks the user's access to designer forms based on their login status, user type, and designer form permissions.
   * If the user is logged in, has a standard user type, and has designer form permissions, or if the user is logged in as an admin,
   * sets the access to designer forms to true; otherwise, sets it to false.
   */
  if (
    (isLogged === true && userType === enumsTypeUser.STANDARD && designerForms === true) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessDesignerForms = true;
  } else {
    accessDesignerForms = false;
  }

  /**
   * Checks if the user is logged in, has a standard user type, and has permission for designer forms.
   * Sets accessDesignerFormsConsult to true if conditions are met, false otherwise.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    designerFormsPermissions.length !== 0
  ) {
    accessDesignerFormsConsult = true;
  } else {
    accessDesignerFormsConsult = false;
  }

  /**
   * Checks the user's access to the workflows forms based on their login status, user type, and permissions.
   * Sets the accessWorkflowsForms variable to true if the user is logged in as a standard user with access to all workflow forms or as an admin; otherwise, sets it to false.
   */
  if (
    (isLogged === true && userType === enumsTypeUser.STANDARD && workflowAllForms === true) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessWorkflowsForms = true;
  } else {
    accessWorkflowsForms = false;
  }

  /**
   * Checks if the user is logged in, has a standard user type, and has permission to access workflow forms.
   * Sets the accessWorkflowsFormsConsult variable accordingly.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    workflowFormsPermissions.length !== 0
  ) {
    accessWorkflowsFormsConsult = true;
  } else {
    accessWorkflowsFormsConsult = false;
  }

  /**
   * Filter and map enum values to check access permissions.
   * If certain role permissions or user type is admin, set access to admin third-party accounts accordingly.
   * @param {Object} enumsRolesPermissions - Enum values for roles permissions.
   * @param {Object} rolesPermissionsGranted - Role permissions object.
   * @param {string} userType - User type.
   * @param {boolean} accessAdminThirdPartyAccounts - Flag to indicate access to admin third-party accounts.
   */
  const enumValues = Object.values(enumsRolesPermissions)
    .filter(
      (val) =>
        val !== enumsRolesPermissions.TRD_CONSFIGURATION &&
        val !== enumsRolesPermissions.LIST_DESIGNER,
    )
    .map(Number);
  const rolesPermissions = Object.values(rolesPermissionsGranted || {}).map(Number);

  if (
    rolesPermissions.some((val) => enumValues.includes(val)) ||
    userType === enumsTypeUser.ADMIN
  ) {
    accessAdminThirdPartyAccounts = false;
  } else {
    accessAdminThirdPartyAccounts = true;
  }

  /**
   * Checks the user's access rights based on their login status, user type, and role permissions.
   * If the user is logged in as a standard user with specific role permissions or as an admin,
   * sets the accessList flag to true; otherwise, sets it to false.
   */
  if (
    (isLogged === true &&
      userType === enumsTypeUser.STANDARD &&
      rolesPermissionsGranted !== null &&
      rolesPermissionsGranted.includes(enumsRolesPermissions.LIST_DESIGNER)) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessList = true;
  } else {
    accessList = false;
  }

  /**
   * Checks the user's access rights to the user manager based on their login status, user type, and role permissions.
   * If the user is logged in as a standard user with specific role permissions or as an admin, grants access to the user manager.
   * @returns {boolean} - True if the user has access to the user manager, false otherwise.
   */
  if (
    (isLogged === true &&
      userType === enumsTypeUser.STANDARD &&
      rolesPermissionsGranted !== null &&
      rolesPermissionsGranted.includes(enumsRolesPermissions.USER_MANAGER)) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessUserManager = true;
  } else {
    accessUserManager = false;
  }

  /**
   * Checks the user's access roles based on login status, user type, and role permissions.
   * If the user is logged in, has a standard user type, and specific role permissions, sets accessRoles to true.
   * If the user is logged in and has an admin user type, sets accessRoles to true.
   * Otherwise, sets accessRoles to false.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    rolesPermissionsGranted !== null &&
    rolesPermissionsGranted.includes(enumsRolesPermissions.ROLE_MANAGER)
  ) {
    accessRoles = true;
  } else if (isLogged === true && userType === enumsTypeUser.ADMIN) {
    accessRoles = true;
  } else {
    accessRoles = false;
  }

  /**
   * Determines the access to integrations based on the user's login status and user type.
   * If the user is logged in and not an admin, access to integrations is denied; otherwise, access is granted.
   */
  if (isLogged === true && userType !== enumsTypeUser.ADMIN) {
    accessIntegrations = false;
  } else {
    accessIntegrations = true;
  }

  /**
   * Determines if the user has access to work groups based on their login status, user type, and role permissions.
   * @param {boolean} isLogged - Indicates if the user is logged in.
   * @param {string} userType - The type of user (QUERY, STANDARD, ADMIN).
   * @param {array} rolesPermissionsGranted - The array of role permissions.
   * @returns {boolean} - True if the user has access to work groups, false otherwise.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    rolesPermissionsGranted !== null &&
    rolesPermissionsGranted.includes(enumsRolesPermissions.WORK_GROUP_MANAGER)
  ) {
    accessWorkGroups = true;
  } else if (isLogged === true && userType === enumsTypeUser.ADMIN) {
    accessWorkGroups = true;
  } else {
    accessWorkGroups = false;
  }

  /**
   * Determines if the user has access to process management based on their login status, user type, and role permissions.
   * @param {boolean} isLogged - Indicates if the user is logged in.
   * @param {string} userType - The type of user (QUERY, STANDARD, ADMIN).
   * @param {array} rolesPermissionsGranted - The array of role permissions.
   * @returns {boolean} - True if the user has access to process management, false otherwise.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    rolesPermissionsGranted !== null &&
    rolesPermissionsGranted.includes(enumsRolesPermissions.PROCESS_MANAGEMENT)
  ) {
    accessProcessManagement = true;
  } else if (isLogged === true && userType === enumsTypeUser.ADMIN) {
    accessProcessManagement = true;
  } else {
    accessProcessManagement = false;
  }

  /**
   * Determines if the user has access to metrics based on their login status, user type, and role permissions.
   * @param {boolean} isLogged - Indicates if the user is logged in.
   * @param {string} userType - The type of user (QUERY, STANDARD, ADMIN).
   * @param {array} rolesPermissionsGranted - The array of role permissions.
   * @returns {boolean} - True if the user has access to metrics, false otherwise.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    rolesPermissionsGranted !== null &&
    rolesPermissionsGranted.includes(enumsRolesPermissions.METRICS)
  ) {
    accessMetrics = true;
  } else if (isLogged === true && userType === enumsTypeUser.ADMIN) {
    accessMetrics = true;
  } else {
    accessMetrics = false;
  }

  /**
   * Determines if the user has access to audit logs based on their login status, user type, and role permissions.
   * @param {boolean} isLogged - Indicates if the user is logged in.
   * @param {string} userType - The type of user (QUERY, STANDARD, ADMIN).
   * @param {array} rolesPermissionsGranted - The array of role permissions.
   * @returns {boolean} - True if the user has access to audit logs, false otherwise.
   */
  if (
    isLogged === true &&
    userType === enumsTypeUser.STANDARD &&
    rolesPermissionsGranted !== null &&
    rolesPermissionsGranted.includes(enumsRolesPermissions.AUDIT_LOG)
  ) {
    accessAuditLogs = true;
  } else if (isLogged === true && userType === enumsTypeUser.ADMIN) {
    accessAuditLogs = true;
  } else {
    accessAuditLogs = false;
  }

  /**
   * Determines whether the current user can access the template designer.
   * Sets `accessTemplateDesigner` to true if the user is logged in and either:
   * - has user type `STANDARD` with the `TEMPLATE_DESIGNER` permission, or
   * - has user type `ADMIN`.
   * Otherwise, sets it to false.
   * Depends on: `isLogged`, `userType`, `rolesPermissionsGranted`,
   * `enumsTypeUser`, and `enumsRolesPermissions`.
   */
  if (
    (isLogged === true &&
      userType === enumsTypeUser.STANDARD &&
      rolesPermissionsGranted !== null &&
      rolesPermissionsGranted.includes(enumsRolesPermissions.TEMPLATE_DESIGNER)) ||
    (isLogged === true && userType === enumsTypeUser.ADMIN)
  ) {
    accessTemplateDesigner = true;
  } else {
    accessTemplateDesigner = false;
  }

  /**
   * Conditionally renders an integrations navigation menu based on access permissions.
   * This function checks if the user has access rights (`access` is `true`) and if integrations
   * access is also granted (`accessIntegrations` is `true`). If both conditions are met, it sets
   * the `renderIntegrationsNav` to a `MetisMenu` component with specified properties for managing
   * integrations navigation. If either condition is not met, `renderIntegrationsNav` is set to `null`,
   * indicating that the integrations navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessIntegrations - A boolean indicating whether the user has integrations access.
   * @param {function} toggleMobileSidebar - A function to handle the toggle action of the mobile sidebar.
   * @param {Object} IntegrationsNav - An object containing the navigation content for integrations.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component if both `access` and `accessIntegrations`
   * are granted; otherwise, returns `null`.
   */
  if (access === true && accessIntegrations === true) {
    renderIntegrationsNav = (
      <MetisMenu
        content={translateNav(IntegrationsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderIntegrationsNav = null;
  }

  /**
   * Conditionally renders a metrics navigation menu based on access permissions.
   * This code snippet evaluates if the user has the necessary access permissions (`access` is `true`).
   * If the access permission is granted, it assigns a `MetisMenu` component to `renderMetricsNav`,
   * with the specified properties to handle metrics navigation. The `MetisMenu` is configured with:
   * - `content` set to `MetricsNav`, providing the navigation content,
   * - `onSelected` callback for handling menu item selection,
   * - Various other props for styling and behavior.
   * If access is not granted (`access` is `false`), `renderMetricsNav` is set to `null`, meaning
   * the metrics navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has access permissions to view metrics.
   * @param {Object} MetricsNav - An object containing the content to be displayed in the metrics navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component if `access` is `true`; otherwise, returns `null`.
   */
  if (access === true && accessMetrics === true && accessAuditLogs === true) {
    renderMetricsNav = (
      <MetisMenu
        content={translateNav(MetricsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else if (access === true && accessMetrics === true && accessAuditLogs === false) {
    renderMetricsNav = (
      <MetisMenu
        content={translateNav(MetricsOnlyNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else if (access === true && accessMetrics === false && accessAuditLogs === true) {
    renderMetricsNav = (
      <MetisMenu
        content={translateNav(MetricsLogsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderMetricsNav = null;
  }

  /**
   * Conditionally renders a workflow designer navigation menu for consultations based on access permissions.
   * This code snippet checks multiple conditions to determine if the workflow designer navigation
   * menu for consultations should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessWorkflowsForms` must be `false` to restrict access to workflows forms,
   * - `accessWorkflowsFormsConsult` must be `true` to grant access to workflow designer consultations.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderWorkFlowDesignerNavConsult`
   * with the specified properties to handle workflow designer navigation. If any of the conditions
   * are not met, `renderWorkFlowDesignerNavConsult` is set to `null`, meaning the navigation menu
   * will not be rendered
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessWorkflowsForms - A boolean indicating whether the user has access to workflows forms.
   * @param {boolean} accessWorkflowsFormsConsult - A boolean indicating whether the user has access to workflow designer consultations.
   * @param {Object} WorkFlowDesignerNavConsult - An object containing the content for the workflow designer consultation navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the workflow designer consultation menu if all access conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessWorkflowsForms === false && accessWorkflowsFormsConsult === true) {
    renderWorkFlowDesignerNavConsult = (
      <MetisMenu
        content={translateNav(WorkFlowDesignerNavConsult)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderWorkFlowDesignerNavConsult = null;
  }

  /**
   * Conditionally renders a workflow designer navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the workflow designer
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessWorkflowsForms` must be `true` to grant access to workflows forms,
   * - `accessWorkflowsFormsConsult` must be `false` to restrict access to workflow designer consultations.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderWorkFlowDesignerNav`
   * with the specified properties to handle the workflow designer navigation. If any of the conditions
   * are not met, `renderWorkFlowDesignerNav` is set to `null`, meaning the menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessWorkflowsForms - A boolean indicating whether the user has access to workflows forms.
   * @param {boolean} accessWorkflowsFormsConsult - A boolean indicating whether the user does not have access to workflow designer consultations.
   * @param {Object} WorkFlowDesignerNav - An object containing the content for the workflow designer navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the workflow designer menu if all access conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessWorkflowsForms === true && accessWorkflowsFormsConsult === false) {
    renderWorkFlowDesignerNav = (
      <MetisMenu
        content={translateNav(WorkFlowDesignerNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderWorkFlowDesignerNav = null;
  }

  /**
   * Conditionally renders the MetisMenu component for admin users' third-party accounts.
   * If both `access` and `accessAdminThirdPartyAccounts` are true, the MetisMenu is rendered
   * with the specified content and configuration. Otherwise, it is set to null.
   * @param {boolean} access - Indicates general access permission.
   * @param {boolean} accessAdminThirdPartyAccounts - Indicates access permission for admin third-party accounts.
   * @returns {JSX.Element|null} The MetisMenu component or null based on access permissions.
   */
  if (access === true && accessAdminThirdPartyAccounts === true) {
    renderAdminUsersThirdPartyAccounts = (
      <MetisMenu
        content={translateNav(AdminUsersThirdPartyAccounts)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersThirdPartyAccounts = null;
  }

  /**
   * Conditionally renders the admin user workgroup navigation menu based on access permissions.
   * This code snippet evaluates multiple conditions to determine if the admin user workgroup
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `false` to restrict access to user management,
   * - `accessRoles` must be `false` to restrict access to roles management,
   * - `accessWorkGroups` must be `true` to grant access to workgroup management.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUserWorkGroupNav`
   * with the specified properties for rendering the admin user workgroup navigation. If any of the
   * conditions are not met, `renderAdminUserWorkGroupNav` is set to `null`, meaning the navigation
   * menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessUserManager - A boolean indicating whether the user has access to user management.
   * @param {boolean} accessRoles - A boolean indicating whether the user has access to roles management.
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user has access to workgroup management.
   * @param {Object} AdminUserWorkGroupNav - An object containing the content for the admin user workgroup navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin user workgroup menu if all access conditions are met;
   * otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === false &&
    accessRoles === false &&
    accessWorkGroups === true
  ) {
    renderAdminUserWorkGroupNav = (
      <MetisMenu
        content={translateNav(AdminUserWorkGroupNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUserWorkGroupNav = null;
  }

  /**
   * Conditionally renders an admin users and roles navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin users and roles
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `false` to restrict access to the user manager,
   * - `accessRoles` must be `true` to grant access to roles management,
   * - `accessWorkGroups` must be `false` to restrict access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUsersRoleNav`
   * with the specified properties to handle the admin users and roles navigation. If any of the conditions
   * are not met, `renderAdminUsersRoleNav` is set to `null`, meaning the menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessUserManager - A boolean indicating whether the user does not have access to the user manager.
   * @param {boolean} accessRoles - A boolean indicating whether the user has access to roles management.
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user does not have access to work groups.
   * @param {Object} AdminUsersRoleNav - An object containing the content for the admin users and roles navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin users and roles menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === false &&
    accessRoles === true &&
    accessWorkGroups === false
  ) {
    renderAdminUsersRoleNav = (
      <MetisMenu
        content={translateNav(AdminUsersRoleNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersRoleNav = null;
  }

  /**
   * Conditionally renders an admin users navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin users
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `true` to grant access to the user manager,
   * - `accessRoles` must be `false` to restrict access to roles management,
   * - `accessWorkGroups` must be `false` to restrict access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUsersNav`
   * with the specified properties to handle admin users navigation. If any of the conditions
   * are not met, `renderAdminUsersNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessUserManager - A boolean indicating whether the user has access to the user manager.
   * @param {boolean} accessRoles - A boolean indicating whether the user does not have access to roles management (must be `false`).
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user does not have access to work groups (must be `false`).
   * @param {Object} AdminUsersNav - An object containing the content for the admin users navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin users menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === true &&
    accessRoles === false &&
    accessWorkGroups === false
  ) {
    renderAdminUsersNav = (
      <MetisMenu
        content={translateNav(AdminUsersNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersNav = null;
  }

  /**
   * Conditionally renders an admin roles and groups navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin roles and groups
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `false` to restrict access to the user manager,
   * - `accessRoles` must be `true` to grant access to roles management,
   * - `accessWorkGroups` must be `true` to grant access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminRoleGroupsNav`
   * with the specified properties to handle admin roles and groups navigation. If any of the conditions
   * are not met, `renderAdminRoleGroupsNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessUserManager - A boolean indicating whether the user does not have access to the user manager.
   * @param {boolean} accessRoles - A boolean indicating whether the user has access to roles management.
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user has access to work groups.
   * @param {Object} AdminRoleGroupsNav - An object containing the content for the admin roles and groups navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin roles and groups menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === false &&
    accessRoles === true &&
    accessWorkGroups === true
  ) {
    renderAdminRoleGroupsNav = (
      <MetisMenu
        content={translateNav(AdminRoleGroupsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminRoleGroupsNav = null;
  }

  /**
   * Conditionally renders an admin users and groups navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin users and groups
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `true` to grant access to the user manager,
   * - `accessRoles` must be `false` to restrict access to roles management,
   * - `accessWorkGroups` must be `true` to grant access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUsersGroupsNav`
   * with the specified properties to handle admin users and groups navigation. If any of the conditions
   * are not met, `renderAdminUsersGroupsNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessUserManager - A boolean indicating whether the user has access to the user manager.
   * @param {boolean} accessRoles - A boolean indicating whether the user does not have access to roles management (must be `false`).
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user has access to work groups.
   * @param {Object} AdminUsersGroupsNav - An object containing the content for the admin users and groups navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin users and groups menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === true &&
    accessRoles === false &&
    accessWorkGroups === true
  ) {
    renderAdminUsersGroupsNav = (
      <MetisMenu
        content={translateNav(AdminUsersGroupsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersGroupsNav = null;
  }

  /**
   * Conditionally renders an admin users and roles navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin users and roles
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `true` to grant access to the user manager,
   * - `accessRoles` must be `true` to grant access to roles management,
   * - `accessWorkGroups` must be `false` to restrict access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUsersAndRoleNav`
   * with the specified properties to handle admin users and roles navigation. If any of the conditions
   * are not met, `renderAdminUsersAndRoleNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessUserManager - A boolean indicating whether the user has access to the user manager. This must be `true`.
   * @param {boolean} accessRoles - A boolean indicating whether the user has access to roles management. This must be `true`.
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user does not have access to work groups. This must be `false`.
   * @param {Object} AdminUsersAndRoleNav - An object containing the content for the admin users and roles navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin users and roles menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === true &&
    accessRoles === true &&
    accessWorkGroups === false
  ) {
    renderAdminUsersAndRoleNav = (
      <MetisMenu
        content={translateNav(AdminUsersAndRoleNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersAndRoleNav = null;
  }

  /**
   * Conditionally renders an admin users, roles, and groups navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the admin users, roles, and
   * groups navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessUserManager` must be `true` to grant access to the user manager,
   * - `accessRoles` must be `true` to grant access to roles management,
   * - `accessWorkGroups` must be `true` to grant access to work groups.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderAdminUsersAndRoleGroupsNav`
   * with the specified properties to handle admin users, roles, and groups navigation. If any of the conditions
   * are not met, `renderAdminUsersAndRoleGroupsNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessUserManager - A boolean indicating whether the user has access to the user manager. This must be `true`.
   * @param {boolean} accessRoles - A boolean indicating whether the user has access to roles management. This must be `true`.
   * @param {boolean} accessWorkGroups - A boolean indicating whether the user has access to work groups. This must be `true`.
   * @param {Object} AdminUsersAndRoleGroupsNav - An object containing the content for the admin users, roles, and groups navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the admin users, roles, and groups menu if all access conditions are met; otherwise, returns `null`.
   */
  if (
    access === true &&
    accessUserManager === true &&
    accessRoles === true &&
    accessWorkGroups === true
  ) {
    renderAdminUsersAndRoleGroupsNav = (
      <MetisMenu
        content={translateNav(AdminUsersAndRoleGroupsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderAdminUsersAndRoleGroupsNav = null;
  }

  /**
   * Conditionally renders a list designer navigation menu based on access permissions.
   * This code snippet evaluates two access permissions to determine if the list designer navigation
   * menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessList` must be `true` to grant access to the list designer functionality.
   * If both conditions are met, it assigns a `MetisMenu` component to `renderListDesignerForm`
   * with the specified properties to handle the list designer navigation. If any of the conditions
   * are not met, `renderListDesignerForm` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessList - A boolean indicating whether the user has access to the list designer functionality. This must be `true`.
   * @param {Object} ListDesignerNav - An object containing the content for the list designer navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the list designer navigation menu if all access conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessList === true) {
    renderListDesignerForm = (
      <MetisMenu
        content={translateNav(ListDesignerNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderListDesignerForm = null;
  }

  /**
   * Conditionally renders a forms designer navigation menu for consultations based on access permissions.
   * This code snippet evaluates several access permissions to determine if the forms designer
   * navigation menu for consultations should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessDesignerForms` must be `false` to restrict access to the designer forms functionality,
   * - `accessDesignerFormsConsult` must be `true` to grant access to the forms designer consultations.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderFormsDesignerNavConsult`
   * with the specified properties to handle the forms designer consultation navigation. If any of the
   * conditions are not met, `renderFormsDesignerNavConsult` is set to `null`, meaning the navigation
   * menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessDesignerForms - A boolean indicating whether the user does not have access to the designer forms functionality. This must be `false`.
   * @param {boolean} accessDesignerFormsConsult - A boolean indicating whether the user has access to forms designer consultations. This must be `true`.
   * @param {Object} FormsDesignerNavConsult - An object containing the content for the forms designer navigation menu for consultations.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the forms designer navigation menu for consultations if all access conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessDesignerForms === false && accessDesignerFormsConsult === true) {
    renderFormsDesignerNavConsult = (
      <MetisMenu
        content={translateNav(FormsDesignerNavConsult)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderFormsDesignerNavConsult = null;
  }

  /**
   * Conditionally renders a forms designer navigation menu based on access permissions.
   * This code snippet evaluates several access permissions to determine if the forms designer
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessDesignerForms` must be `true` to grant access to the forms designer functionality,
   * - `accessDesignerFormsConsult` must be `false` to restrict access to forms designer consultations.
   * If all conditions are met, it assigns a `MetisMenu` component to `renderFormsDesignerNav`
   * with the specified properties to handle the forms designer navigation. If any of the conditions
   * are not met, `renderFormsDesignerNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessDesignerForms - A boolean indicating whether the user has access to the forms designer functionality. This must be `true`.
   * @param {boolean} accessDesignerFormsConsult - A boolean indicating whether the user does not have access to forms designer consultations. This must be `false`.
   * @param {Object} FormsDesignerNav - An object containing the content for the forms designer navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the forms designer navigation menu if all access conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessDesignerForms === true && accessDesignerFormsConsult === false) {
    renderFormsDesignerNav = (
      <MetisMenu
        content={translateNav(FormsDesignerNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderFormsDesignerNav = null;
  }

  /**
   * Conditionally renders a parameter documentary type navigation menu based on access permissions.
   * This code snippet evaluates access permissions to determine if the parameter documentary type
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessTRD` must be `false` to restrict access to TRD (presumably "Technical Reference Documents" or similar).
   * If the conditions are met, it assigns a `MetisMenu` component to `renderParameterDocumentaryTypeNav`
   * with the specified properties to handle the parameter documentary type navigation. If the conditions
   * are not met, `renderParameterDocumentaryTypeNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessTRD - A boolean indicating whether the user does not have access to TRD. This must be `false`.
   * @param {Object} ParameterDocumentaryTypeNav - An object containing the content for the parameter documentary type navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the parameter documentary type navigation menu if the conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessTRD === false) {
    renderParameterDocumentaryTypeNav = (
      <MetisMenu
        content={translateNav(ParameterDocumentaryTypeNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderParameterDocumentaryTypeNav = null;
  }

  /**
   * Conditionally renders a parameter navigation menu based on access permissions.
   * This code snippet evaluates access permissions to determine if the parameter
   * navigation menu should be rendered:
   * - `access` must be `true` to grant general access permissions,
   * - `accessTRD` must also be `true` to allow access to the TRD (presumably "Technical Reference Documents" or similar).
   * If both conditions are met, it assigns a `MetisMenu` component to `renderParameterNav`
   * with the specified properties to handle the parameter navigation. If the conditions
   * are not met, `renderParameterNav` is set to `null`, meaning the navigation menu will not be rendered.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions. This must be `true`.
   * @param {boolean} accessTRD - A boolean indicating whether the user has access to TRD. This must be `true`.
   * @param {Object} ParameterNav - An object containing the content for the parameter navigation menu.
   * @param {function} toggleMobileSidebar - A function to handle the action of toggling the mobile sidebar.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component with the parameter navigation menu if the conditions are met; otherwise, returns `null`.
   */
  if (access === true && accessTRD === true) {
    renderParameterNav = (
      <MetisMenu
        content={translateNav(ParameterNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderParameterNav = null;
  }

  /**
   * Conditionally renders a navigation menu based on the access permission.
   * This function checks if the user has the necessary access rights (`access` is `true`).
   * If access is granted, it sets the `renderProcessManagementNav` to a `MetisMenu` component
   * with the specified properties for managing process navigation.
   * If access is not granted, `renderProcessManagementNav` is set to `null`, meaning no
   * navigation menu will be rendered.
   * @param {boolean} access - A boolean indicating whether the user has access permissions.
   * @param {function} toggleMobileSidebar - A function to handle sidebar toggle actions.
   * @param {Object} ProcessManagementNav - An object containing the navigation content for process management.
   * @param {Object} MetisMenu - The MetisMenu component used for rendering the navigation menu.
   * @returns {JSX.Element|null} - Returns a `MetisMenu` component if access is granted; otherwise, returns `null`.
   */
  if (access === true && accessProcessManagement === true) {
    renderProcessManagementNav = (
      <MetisMenu
        content={translateNav(ProcessManagementNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderProcessManagementNav = null;
  }

  /**
   * Conditionally renders the process management navigation menu based on the value of `integrationOptions[1]`.
   * The `MetisMenu` component is configured with several props:
   * - `content`: The menu items to be displayed, which is `ReportsNav` in this case.
   * - `onSelected`: A callback function that is called when a menu item is selected. It is set to `toggleMobileSidebar`.
   * - `activeLinkFromLocation`: A boolean that determines if the active link should be determined from the current location.
   * - `className`: The CSS class to apply styles to the menu, which is `"vertical-nav-menu"` here.
   * - `iconNamePrefix`: The prefix for the icon class names, which is empty in this case.
   * - `classNameStateIcon`: The CSS class for the state icon, set to `"pe-7s-angle-down"`
   * @param {Array<string>} integrationOptions - An array of string values representing integration options.
   * @param {Function} toggleMobileSidebar - A function to be called when a menu item is selected.
   * @param {Object} ReportsNav - The content for the `MetisMenu` when `integrationOptions[1]` is `"1"`
   * @returns {JSX.Element|null} The rendered `MetisMenu` component if `integrationOptions[1]` is `"1"`, otherwise `null`.
   */
  if (
    integrationOptions !== null &&
    (integrationOptions.includes(enumsIntegrationType.ELECTRONIC_SIGNATURE) ||
      integrationOptions.includes(enumsIntegrationType.VIRTUAL_TOKEN))
  ) {
    renderReportsNav = (
      <MetisMenu
        content={translateNav(ReportsNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderReportsNav = null;
  }

  /**
   * Renders the navigation menu based on the state of `viewSubMenuExpedientConsult`.
   * This code snippet conditionally renders a `MetisMenu` component based on the boolean value of `viewSubMenuExpedientConsult`.
   * - When `viewSubMenuExpedientConsult` is `true`, the `MetisMenu` is rendered with `ConsultRecordNavTrdExplorer` as its content.
   * - When `viewSubMenuExpedientConsult` is `false`, the `MetisMenu` is rendered with `ConsultRecordNav` as its content.
   * @param {boolean} viewSubMenuExpedientConsult - A boolean flag to determine which menu content to display.
   * @param {Function} toggleMobileSidebar - A function to be called when a menu item is selected.
   * @param {Object} ConsultRecordNav - The content to be used for the menu when `viewSubMenuExpedientConsult` is `false`.
   * @param {Object} ConsultRecordNavTrdExplorer - The content to be used for the menu when `viewSubMenuExpedientConsult` is `true`.
   * @returns {JSX.Element} The rendered `MetisMenu` component based on the `viewSubMenuExpedientConsult` flag.
   */
  if (viewSubMenuExpedientConsult === true) {
    renderListDesignerNav = (
      <MetisMenu
        content={translateNav(ConsultRecordNavTrdExplorer)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderListDesignerNav = (
      <MetisMenu
        content={translateNav(ConsultRecordNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  }

  /**
   * Renders the Document Templates Designer navigation menu using MetisMenu
   * when access is granted.
   * @param {boolean} access - Determines if the navigation menu should be rendered.
   * @param {object} DocumentTemplatesDesignerNav - The content for the navigation menu.
   * @returns {JSX.Element|null} The rendered MetisMenu component or null if access is denied.
   */
  if (access === true && accessTemplateDesigner === true) {
    renderTemplatesDesignerNav = (
      <MetisMenu
        content={translateNav(DocumentTemplatesDesignerNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
    );
  } else {
    renderTemplatesDesignerNav = null;
  }

  /**
   * Conditionally renders a title heading for the vertical navigation menu based on access permissions.
   * This snippet checks if the user has general access (`access` is `true`). If access is granted,
   * it sets `titleHeadingNav` to an `<h5>` element with a class of `"app-sidebar__heading"` and
   * a localized title text fetched using the `t` function. If access is not granted,
   * `titleHeadingNav` is set to `null`, meaning no heading will be rendered.
   * @param {boolean} access - A boolean indicating whether the user has access permissions.
   * @param {Object} i18n - An object used for internationalization that provides localization functions.
   * @param {function} t - A function used to fetch localized text based on a key.
   * @returns {JSX.Element|null} - Returns an `<h5>` element with the localized title if `access` is true;
   * otherwise, returns `null`.
   */
  if (access === true) {
    titleHeadingNav = <h5 className="app-sidebar__heading">{t("verticalNav.tittle2")}</h5>;
  } else {
    titleHeadingNav = null;
  }

  /**
   * Conditionally renders a title for the integrations section based on access permissions.
   * This code snippet checks if the user has both general access (`access` is `true`) and
   * integrations access (`accessIntegrations` is `true`). If both conditions are met, it sets
   * `renderTitleIntegrations` to a `<h5>` element with a class of `"app-sidebar__heading"`
   * and a localized text for the integrations navigation title. If either condition is not met,
   * `renderTitleIntegrations` is set to `null`, which means the title will not be displayed.
   * @param {boolean} access - A boolean indicating whether the user has general access permissions.
   * @param {boolean} accessIntegrations - A boolean indicating whether the user has integrations access permissions.
   * @param {Object} i18n - An object for internationalization (i18n) that provides localization functions.
   * @param {function} t - A function to translate or get localized text.
   * @returns {JSX.Element|null} - Returns an `<h5>` element with the title if both `access` and `accessIntegrations`
   * are granted; otherwise, returns `null`.
   */
  if (access === true && accessIntegrations === true) {
    renderTitleIntegrations = <h5 className="app-sidebar__heading">{t("integrations.nav")}</h5>;
  } else {
    renderTitleIntegrations = null;
  }

  return (
    <Fragment>
      <h5 className="app-sidebar__heading"> </h5>
      <MetisMenu
        content={translateNav(DashboardNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />

      <h5 className="app-sidebar__heading">{t("verticalNav.tittle1")}</h5>
      <MetisMenu
        content={translateNav(CreateRecordNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />
      {renderListDesignerNav}

      <MetisMenu
        content={translateNav(TaskBoxNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />

      {renderReportsNav}

      {renderProcessManagementNav}

      <MetisMenu
        content={translateNav(TrashNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />

      <MetisMenu
        content={translateNav(DataExportNav)}
        activeLinkFromLocation
        className="vertical-nav-menu"
        iconNamePrefix=""
        classNameStateIcon="pe-7s-angle-down"
      />

      {titleHeadingNav}

      {renderParameterNav}

      {renderParameterDocumentaryTypeNav}

      {renderFormsDesignerNav}

      {renderFormsDesignerNavConsult}

      {renderListDesignerForm}

      {renderWorkFlowDesignerNav}

      {renderTemplatesDesignerNav}

      {renderWorkFlowDesignerNavConsult}

      {renderAdminUsersThirdPartyAccounts}

      {renderAdminUsersAndRoleGroupsNav}

      {renderAdminUsersAndRoleNav}

      {renderAdminUsersGroupsNav}

      {renderAdminRoleGroupsNav}

      {renderAdminUsersNav}

      {renderAdminUsersRoleNav}

      {renderAdminUserWorkGroupNav}

      {renderMetricsNav}

      {renderTitleIntegrations}

      {renderIntegrationsNav}
    </Fragment>
  );
};

/**
 *Maps the state properties to the props of a component for accessing 'enableMobileMenu' state from the Redux store.
 *@param {Object} state - The current state object from the Redux store.
 *@returns {Object} An object containing the 'enableMobileMenu' property that will be accessible as a prop in the component.
 */
const mapStateToProps = (state) => ({
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

/**
 *Connects the 'setEnableMobileMenu' action creator to the component's props,
 *allowing the component to dispatch the action to enable or disable the mobile menu through the Redux store.
 *@param {function} dispatch - A function provided by Redux to dispatch actions to the store
 *@returns {object} An object containing the 'setEnableMobileMenu' prop, which is a function that can be used to
 *dispatch the action to enable or disable the mobile menu.
 */
const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Nav));
